'use client';

import { callEdgeFunction } from "@/lib/rpc/utils/edgeFunctions";
import * as React from 'react';

const isPrd = import.meta.env.VITE_ENV_LABEL === 'PRD';

export function useRealtimeCustomers(onCustomerUpdate?: (customer: any) => void) {
  React.useEffect(() => {
    // Use facade for realtime subscriptions instead of direct client
    const connectRealtime = async () => {
      try {
        await callEdgeFunction('realtime-connect', { 
          channel: 'customers',
          table: 'customers',
          schema: 'public'
        });
      } catch (error) {
        console.error('[Realtime] Failed to connect to customers stream:', error);
      }
    };
    
    connectRealtime();

    // Note: Actual realtime functionality would need to be implemented through facade
    // This is a placeholder to maintain API compatibility
    return () => {
      if (!isPrd) console.log('[Realtime] Disconnecting from customers stream');
    };
  }, [onCustomerUpdate]);
}

export function useRealtimeTransactions(onTransactionUpdate?: (transaction: any) => void) {
  React.useEffect(() => {
    // Use facade for realtime subscriptions instead of direct client
    const connectRealtime = async () => {
      try {
        await callEdgeFunction('realtime-connect', { 
          channel: 'transactions',
          table: 'transactions',
          schema: 'public'
        });
      } catch (error) {
        console.error('[Realtime] Failed to connect to transactions stream:', error);
      }
    };
    
    connectRealtime();

    // Note: Actual realtime functionality would need to be implemented through facade
    // This is a placeholder to maintain API compatibility
    return () => {
      if (!isPrd) console.log('[Realtime] Disconnecting from transactions stream');
    };
  }, [onTransactionUpdate]);
}

// Main export for dashboard compatibility
export function useRealtimeUpdates() {
  // Placeholder function for dashboard compatibility
  React.useEffect(() => {
    if (!isPrd) console.log('[Realtime] Dashboard updates initialized');
  }, []);
}